var app = app || {};

app.masonry = (function ($) {


    masonryInit = function() {
        var $grid = $( '#wall' ).masonry( {
            itemSelector: '.entry',
            columnWidth: '.wall__column',
            gutter: '.wall__gutter',
            percentPosition: true
        } );
        $grid.imagesLoaded().progress(function() {
            $grid.masonry('layout');
        });
    },

    init = function () {
        masonryInit();
    };

    return {
        init: init
    }    	

}( jQuery, this ));

jQuery(app.masonry.init);